import React, { FC } from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useSelector } from 'react-redux';

import { CheckFilledIcon, Status } from 'src/shared/components';
import { formatInputDuration } from 'src/shared/utils';
import { getDurationFormat } from 'src/store/user/user.selectors';

interface Props {
  duration: number | null;
  isAuthorized: boolean | null;
}

export const TimesheetExtraTimeCell: FC<Props> = ({ duration, isAuthorized }) => {
  const durationFormat = useSelector(getDurationFormat);

  return (
    (!!duration || isAuthorized) && (
      <Stack direction="row" width="100%" height="100%" justifyContent="center" alignItems="center" gap={1}>
        {isAuthorized ? <CheckFilledIcon size={20} color="#598F17" /> : <Status size="medium" />}
        {!!duration && (
          <Typography fontSize="0.875rem" fontWeight={500}>
            {formatInputDuration(duration, durationFormat, 'seconds', false)}
          </Typography>
        )}
      </Stack>
    )
  );
};
